<script>
import Layout from '@layout/main'
import { BRAND } from '@src/config/fake-data'
import { messageSuccess, messageError } from '@utils/message'
import formatDate from '@utils/format-date'
import ContactLayout from './components/MenuList'

const rmaBrands = [
  {
    text: 'AXIS',
    value: 'A3',
  },
  {
    text: 'CISCO',
    value: 'C2',
  },
  {
    text: 'F5',
    value: 'F5',
  },
  {
    text: 'Logitech',
    value: 'L4',
  },
  {
    text: 'Microsoft',
    value: 'M1',
  },
  {
    text: 'NetApp',
    value: 'N3',
  },
  {
    text: 'Nutanix',
    value: 'N8',
  },
  {
    text: 'NVIDIA',
    value: 'N7',
  },
  {
    text: 'ORing',
    value: 'O3',
  },
  {
    text: 'Palo Alto Networks',
    value: 'P3',
  },
  {
    text: 'Radware',
    value: 'R2',
  },
  {
    text: 'Synology',
    value: 'SD',
  },
  {
    text: 'Trellix (FireEye)',
    value: 'F3',
  },
  {
    text: 'VIVOTEK',
    value: '2V',
  },
  {
    text: '其它(含軟體)',
    value: 'Z9',
  },
]
const DEFAULT_APPLICATIONSUBMITDATA = {
  customer: 0,
  companyName: '',
  contactName: '',
  phoneCode: '',
  phoneNumber: '',
  phoneExt: '',
  faxCode: '',
  faxMobile: '',

  city: '',
  district: '',
  address: '',

  email: '',
  backEmail: '',
  otherInfo: '',
  brand: '',
  productModel: '',
  serialNumber: '',
  sendWay: 1,
  objectStatus: 0,
  faultId: 36,
  description: '',
  memo: '',
}

const DEFAULT_QUERYSUBMITDATA = {
  filed1: '維修編號',
  number: '',
  email: '',
  phoneCode: '',
  phoneNumber: '',
  phoneExtension: '',
}

export default {
  page() {
    return {
      title: `維修服務 | 關於我們`,
    }
  },
  components: {
    ContactLayout,
  },
  data() {
    return {
      dialogVisible: false,
      formatDate,
      applyNumber: '',
      activeProcessStep: 6,
      processStepList: [
        {
          title: '客戶維修申請',
          description: '',
        },
        {
          title: '確認故障',
          description: '',
        },
        {
          title: '線上維修申請',
          description: '',
        },
        {
          title: '確認維修報價',
          description: '依貨品是否為本公司出貨及是否在保固期之期限內',
        },
        {
          title: '客戶驗收',
          description: '',
        },
        {
          title: '維修完成',
          description: '',
        },
      ],

      activeSeriveType: 'application',

      applicationStepActive: 0,
      applicationStepList: [
        {
          title: '填寫維修資料',
          description: '',
        },
        {
          title: '確認報修資訊',
          description: '',
        },
        {
          title: '報修成功',
          description: '',
        },
      ],

      applicationSubmitData: {
        customer: 0,
        companyName: '',
        contactName: '',
        phoneCode: '',
        phoneNumber: '',
        phoneExt: '',
        faxCode: '',
        faxMobile: '',

        city: '',
        district: '',
        address: '',

        email: '',
        backEmail: '',
        otherInfo: '',
        brand: '',
        productModel: '',
        serialNumber: '',
        sendWay: 1,
        objectStatus: 0,
        faultId: 36,
        description: '',
        memo: '',
      },
      applicationFiledList: [
        {
          col: 3,
          type: 'font',
          label: '報修日期',
          placeholder: '',
          font: formatDate(new Date()),
          rules: '',
        },
        {
          col: 9,
          type: 'radio',
          label: '客戶屬性',
          placeholder: '',
          name: 'customer',
          rules: '',
          options: [
            {
              text: '一般使用者STD',
              value: 0,
            },
            {
              text: '經銷商ASP',
              value: 1,
            },
            {
              text: 'SSC/ASP',
              value: 2,
            },
          ],
        },
        {
          col: 6,
          type: 'text',
          label: '公司名稱',
          placeholder: '',
          name: 'companyName',
          rules: 'require',
        },
        {
          col: 6,
          type: 'text',
          label: '聯絡人',
          placeholder: '',
          name: 'contactName',
          rules: 'require',
        },
        {
          col: 3,
          type: 'areaCode',
          label: '聯絡電話區碼',
          placeholder: '請選擇區碼',
          name: 'phoneCode',
          rules: 'require',
        },
        {
          col: 6,
          type: 'text',
          label: '聯絡電話',
          placeholder: '聯絡電話',
          name: 'phoneNumber',
          rules: 'require|number',
        },
        {
          col: 3,
          type: 'text',
          label: '分機',
          placeholder: '分機',
          name: 'phoneExt',
          rules: '',
          isTransparentLabel: true,
        },
        {
          col: 3,
          type: 'faxCode',
          label: '手機/傳真國碼',
          placeholder: '請選擇手機/傳真國碼',
          name: 'faxCode',
          rules: '',
        },
        {
          col: 9,
          type: 'text',
          label: '手機/傳真',
          placeholder: '手機/傳真',
          name: 'faxMobile',
          rules: 'number',
        },
        {
          col: 3,
          type: 'city',
          label: '聯絡地址',
          placeholder: '請選擇縣市',
          name: 'city',
          rules: 'require',
        },
        {
          col: 3,
          type: 'district',
          label: '區域',
          placeholder: '請選擇區域',
          name: 'district',
          rules: 'require',
          isTransparentLabel: true,
        },
        {
          col: 6,
          type: 'text',
          label: '地址',
          placeholder: '地址',
          name: 'address',
          rules: 'require',
          isTransparentLabel: true,
        },
        {
          col: 6,
          type: 'email',
          label: 'E-mail',
          placeholder: '',
          name: 'email',
          rules: 'require|email',
          description: '聯絡電話、E-Mail為日後查修之依據，請填入正確資訊',
        },
        {
          col: 6,
          type: 'email',
          label: '備用E-mail',
          placeholder: '備用E-mail',
          name: 'backEmail',
          rules: '',
          isTransparentLabel: true,
        },
        {
          col: 12,
          type: 'textarea',
          label: '其他資訊',
          placeholder: '',
          name: 'otherInfo',
          rules: '',
        },
        {
          col: 12,
          type: 'hr',
        },
        {
          col: 3,
          type: 'select',
          label: '廠牌',
          placeholder: '請選擇廠牌',
          name: 'brand',
          rules: 'require',
          options: rmaBrands,
        },
        {
          col: 3,
          type: 'text',
          label: '產品型號',
          placeholder: '請選擇產品型號',
          name: 'productModel',
          rules: 'require',
        },
        {
          col: 6,
          type: 'text',
          label: '序號或ID',
          placeholder: '序號或ID',
          name: 'serialNumber',
          rules: 'require',
        },
        {
          col: 12,
          type: 'radio',
          label: '送件方式',
          name: 'sendWay',
          rules: '',
          options: [
            {
              text: '郵寄',
              value: 1,
            },
            {
              text: '自送',
              value: 0,
            },
          ],
        },
        {
          col: 12,
          type: 'radio',
          label: '送修品狀態',
          name: 'objectStatus',
          rules: '',
          options: [
            {
              text: '新裝機',
              value: 0,
            },
            {
              text: '保固設備',
              value: 1,
            },
            {
              text: '保固外設備',
              value: 2,
            },
            {
              text: '既有案件補單',
              value: 3,
            },
          ],
        },
        {
          col: 12,
          type: 'radio',
          label: '故障代碼表',
          name: 'faultId',
          rules: '',
          options: [
            {
              text: '[Disk故障]',
              value: 36,
            },
            {
              text: '[服務中斷]',
              value: 37,
            },
            {
              text: '[效能問題]',
              value: 38,
            },
            {
              text: '[問題諮詢]',
              value: 39,
            },
            {
              text: '[零件故障]',
              value: 40,
            },
          ],
        },
        {
          col: 12,
          type: 'textarea',
          label: '故障描述',
          name: 'description',
          rules: 'require',
        },
        {
          col: 12,
          type: 'textarea',
          label: '維修品備註',
          name: 'memo',
          rules: '',
          description: '請輸入維修品備註!!如有隨貨附零配件or合約License項目請加註。<br>如無，請填無',
        },
      ],
      loadingApplicationSubmit: false,

      queryStepActive: 0,
      queryStepList: [
        {
          title: '輸入查詢資料',
          description: '',
        },
        {
          title: '查詢結果',
          description: '',
        },
        {
          title: '查修明細資料',
          description: '',
        },
      ],

      querySubmitData: {
        filed1: '維修編號',
        number: '',
        email: '',
        phoneCode: '',
        phoneNumber: '',
        phoneExtension: '',
      },
      queryFiledList: [
        {
          col: 3,
          type: 'radio',
          label: '查詢方式',
          placeholder: '',
          name: 'filed1',
          rules: 'require',
          options: [
            {
              text: '維修編號',
              value: '維修編號',
            },
            {
              text: '電子郵件',
              value: '電子郵件',
            },
          ],
        },
        {
          col: 9,
          type: 'text',
          label: '維修編號',
          placeholder: '請輸入維修編號',
          name: 'number',
          rules: 'require',
          isTransparentLabel: true,
          displayRule: () => {
            return this.querySubmitData.filed1 === '維修編號'
          },
        },
        {
          col: 9,
          type: 'email',
          label: '電子郵件',
          placeholder: '請輸入電子郵件',
          name: 'email',
          rules: 'require|email',
          isTransparentLabel: true,
          displayRule: () => {
            return this.querySubmitData.filed1 === '電子郵件'
          },
        },
        {
          col: 3,
          type: 'areaCode',
          label: '聯絡電話區碼',
          placeholder: '請選擇區碼',
          name: 'phoneCode',
          rules: 'require',
        },
        {
          col: 6,
          type: 'text',
          label: '聯絡電話',
          placeholder: '聯絡電話',
          name: 'phoneNumber',
          rules: 'require|number',
        },
        {
          col: 3,
          type: 'text',
          label: '分機',
          placeholder: '分機',
          name: 'phoneExtension',
          rules: '',
          isTransparentLabel: true,
        },
      ],
      loadingQuerySubmit: false,
      queryResults: [],

      showProcessImg: false,

      customerMap: {
        0: '一般使用者STD',
        1: '經銷商ASP',
        2: 'SSC/ASP',
      },
      sendWayMap: {
        0: '自送',
        1: '郵寄',
      },
      objectStatusMap: {
        0: '新裝機',
        1: '保固設備',
        2: '保固外設備',
        3: '既有案件補單',
      },
      faultIdMap: {
        36: '[Disk故障]',
        37: '[服務中斷]',
        38: '[效能問題]',
        39: '[問題諮詢]',
        40: '[零件故障]',
      },
    }
  },
  methods: {
    onSubmitApplication() {
      this.tryToXxxxxApplication()
    },
    onSubmitQuery() {
      this.tryToXxxxxQuery()
    },
    async tryToXxxxxApplication() {
      this.loadingApplicationSubmit = true
      const { district, mobilePhoneCode, mobilePhone } = this.applicationSubmitData
      const mobileFaxCode = () => {
        if (mobilePhoneCode !== '+886') {
          return {
            faxCode: mobilePhoneCode,
            fax: mobilePhone,
            mobilePhoneCode: '',
            mobilePhone: '',
          }
        }
      }
      const submitData = {
        ...this.applicationSubmitData,
        zipCode: district.split(' ')[0],
        district: district.split(' ')[1],
        ...mobileFaxCode,
      }
      // console.log(submitData)
      await this.$store
        .dispatch('global/applyRMA', submitData)
        .then((data) => {
          this.applyNumber = data.number
          this.goToStep(2, 'application')
          this.scrollToFromTop()
        })
        .finally(() => {
          this.loadingApplicationSubmit = false
        })

      /* setTimeout(() => {
         this.loadingApplicationSubmit = false;
         this.goToStep(2, 'application');
         this.scrollToFromTop()
         }, 1000) */
    },
    async tryToXxxxxQuery() {
      this.loadingQuerySubmit = true
      const { filed1, number, email } = this.querySubmitData
      const queryData = {
        ...this.querySubmitData,
        filed1: undefined,
        number: filed1 === '維修編號' ? number : undefined,
        email: filed1 === '維修編號' ? undefined : email,
      }
      await this.$store
        .dispatch('global/searchRMA', queryData)
        .then((data) => {
          // console.log(data)
          if (data) {
            this.applicationSubmitData = {
              ...this.applicationSubmitData,
              ...data[0],
            }
            this.queryResults = data
            this.goToStep(1, 'query')
            this.scrollToFromTop()
          } else {
            messageError('資料錯誤，請重新確認')
          }
        })
        .catch((e) => {
          messageError('資料錯誤，請重新確認')
        })
        .finally(() => {
          this.loadingQuerySubmit = false
        })
    },
    clearFrom(type) {
      this.$refs[`${type}Form`].resetFields()
      if (type === 'query') {
        this.querySubmitData = { ...DEFAULT_QUERYSUBMITDATA }
      } else if (type === 'application') {
        this.applicationSubmitData = { ...DEFAULT_APPLICATIONSUBMITDATA }
      }
    },
    reset() {
      this.againSend('query')
      this.againSend('application')
    },
    goToStep(step, type) {
      this[`${type}StepActive`] = step
      this.scrollToFromTop()
    },
    formatFiled(filed) {
      return filed || '<span class="text-gray-4">(無)</span>'
    },
    againSend(type) {
      this.goToStep(0, type)
      if (this.$refs[`${type}Form`] !== undefined) {
        this.$nextTick(() => {
          this.clearFrom(type)
        })
      }
    },
    scrollToFromTop() {
      const scrollTo = this.getOffsetTop(this.$refs.fromTop)

      TweenMax.to(window, 1, { scrollTo: { y: scrollTo }, ease: Power3.easeOut })
    },
    getOffsetTop(element) {
      let offsetTop = 0

      while (element) {
        offsetTop += element.offsetTop - element.scrollLeft + element.clientTop
        element = element.offsetParent
      }

      return offsetTop
    },
    stepTitle(index) {
      const map = ['掛號報修', '到件時間', '零壹維修', '付費通知', '付費確認', '原廠維修', '原廠送返', '檢修確認', '新機採購', '物流送返', '客戶自取', '結案']
      return map[index]
    },
  },
}
</script>
<template>
  <ContactLayout>
    <!-- <BaseBanner
      title="維修服務"
      :image="require('@assets/images/repair/index_banner.jpg')"
    /> -->

    <section :class="$style.sectionApplication" class="section">
      <div class="container">
        <div class="text-center">
          <BaseSectionTitle title="維修服務項目" />
          <el-radio-group v-model="activeSeriveType" class="isStyleOutlinButton mb-3" @change="reset">
            <el-radio label="application" border> 線上維修申請 </el-radio>
            <el-radio label="query" border> 線上進度查詢 </el-radio>
          </el-radio-group>
        </div>
        <div ref="fromTop" class="py-2 px-3 mb-5 text-center" style="background: #fff0f0">
          *ZOT印表伺服器之維修服務自2018/06/02起轉由<a class="text-primary hover:text-primary-hover" target="_blank" style="text-decoration: underline" href="http://www.zot.com.tw/">源壹科技</a>服務
        </div>
        <!--線上維修申請-->
        <div v-if="activeSeriveType === 'application'" :class="$style.contactBox" class="bg-gray-2">
          <div class="contactBox__title">線上維修申請</div>
          <BaseStep v-model="applicationStepActive" :list="applicationStepList" />
          <hr />
          <!--步驟一-->
          <template v-if="applicationStepActive === 0">
            <BaseForm
              ref="applicationForm"
              key="application"
              v-model="applicationSubmitData"
              :list="applicationFiledList"
              confirm-text="下一步"
              @cancel="clearFrom('application')"
              @submit="goToStep(1, 'application')"
            />
          </template>
          <!--步驟二-->
          <template v-if="applicationStepActive === 1">
            <div :class="$style.formDetail">
              <div class="row">
                <div class="formDetail__left col-md-6 col-12">
                  <div class="formDetail__filedList">
                    <div class="formDetail__filedList__item">
                      <span class="formDetailList__title"> 報修日期： </span>
                      <span class="formDetailList__text">
                        {{ formatDate(new Date()) }}
                      </span>
                    </div>
                    <div class="formDetail__filedList__item">
                      <span class="formDetailList__title"> 客戶屬性： </span>
                      <span v-html="formatFiled(customerMap[applicationSubmitData.customer])"></span>
                    </div>
                    <div class="formDetail__filedList__item">
                      <span class="formDetailList__title"> 公司名稱： </span>
                      <span v-html="formatFiled(applicationSubmitData.companyName)"></span>
                    </div>
                    <div class="formDetail__filedList__item">
                      <span class="formDetailList__title"> 聯絡人： </span>
                      <span v-html="formatFiled(applicationSubmitData.contactName)"></span>
                    </div>
                    <div class="formDetail__filedList__item">
                      <span class="formDetailList__title"> 聯絡電話： </span>
                      {{ applicationSubmitData.phoneCode }} - {{ applicationSubmitData.phoneNumber }} <span v-if="applicationSubmitData.phoneExt">ext {{ applicationSubmitData.phoneExt }}</span>
                    </div>
                    <div class="formDetail__filedList__item">
                      <span class="formDetailList__title"> 手機： </span>
                      <span v-if="applicationSubmitData.faxCode || applicationSubmitData.faxMobile"> {{ applicationSubmitData.faxCode }} - {{ applicationSubmitData.faxMobile }} </span>
                      <span v-else class="text-gray-4"> (無) </span>
                    </div>
                    <div class="formDetail__filedList__item">
                      <span class="formDetailList__title"> 聯絡地址： </span>
                      {{ applicationSubmitData.city }} {{ applicationSubmitData.district }}
                      {{ applicationSubmitData.address }}
                    </div>
                    <div class="formDetail__filedList__item">
                      <span class="formDetailList__title"> E-mail： </span>
                      <span v-html="formatFiled(applicationSubmitData.email)"></span>
                    </div>
                    <div class="formDetail__filedList__item">
                      <span class="formDetailList__title"> 備用E-mail： </span>
                      <span v-html="formatFiled(applicationSubmitData.backEmail)"></span>
                    </div>
                    <div class="formDetail__filedList__item">
                      <span class="formDetailList__title"> 其他資訊： </span>
                      <span v-html="formatFiled(applicationSubmitData.otherInfo)"></span>
                    </div>
                  </div>
                </div>
                <div class="formDetail__right col-md-6 col-12">
                  <div class="formDetail__filedList">
                    <div class="formDetail__filedList__item">
                      <span class="formDetailList__title"> 廠牌： </span>
                      <span v-html="formatFiled(applicationSubmitData.brand)"></span>
                    </div>
                    <div class="formDetail__filedList__item">
                      <span class="formDetailList__title"> 產品型號： </span>
                      <span v-html="formatFiled(applicationSubmitData.productModel)"></span>
                    </div>
                    <div class="formDetail__filedList__item">
                      <span class="formDetailList__title"> 序號或ID： </span>
                      <span v-html="formatFiled(applicationSubmitData.serialNumber)"></span>
                    </div>
                    <div class="formDetail__filedList__item">
                      <span class="formDetailList__title"> 送件方式： </span>
                      <span v-html="formatFiled(sendWayMap[applicationSubmitData.sendWay])"></span>
                    </div>
                    <div class="formDetail__filedList__item">
                      <span class="formDetailList__title"> 送修品狀態： </span>
                      <span v-html="formatFiled(objectStatusMap[applicationSubmitData.objectStatus])"></span>
                    </div>
                    <div class="formDetail__filedList__item">
                      <span class="formDetailList__title"> 故障代碼表： </span>
                      <span v-html="formatFiled(faultIdMap[applicationSubmitData.faultId])"></span>
                    </div>
                    <div class="formDetail__filedList__item">
                      <span class="formDetailList__title"> 故障描述： </span>
                      <span v-html="formatFiled(applicationSubmitData.description)"></span>
                    </div>
                    <div class="formDetail__filedList__item">
                      <span class="formDetailList__title"> 維修品備註： </span>
                      <span v-html="formatFiled(applicationSubmitData.memo)"></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div class="row mt-5">
              <div class="col">
                <BaseButton class="isStylePrimary isSmall isRadius isOutline2 w-100 mb-3" @click="goToStep(0, 'application')"> 修改資訊 </BaseButton>
              </div>
              <div class="col">
                <BaseButton :loading="loadingApplicationSubmit" class="isStylePrimary isSmall isRadius isOutline2 w-100 mb-3" @click="onSubmitApplication"> 確定送出 </BaseButton>
              </div>
            </div>
          </template>
          <!--步驟三-->
          <template v-if="applicationStepActive === 2">
            <div :class="$style.formDetail">
              您的報修已完成!! 維修編號為 <span class="text-primary">{{ applyNumber }}</span>
              <hr />
              <br />請將送修物品妥善包裝後送至下列地址： <br /><br />維修專線: <a href="tel:0800-80-5656">0800-80-5656</a> / <a href="tel:02-26565724">02-26565724</a> <br />送修地址:
              <a href="https://www.google.com.tw/maps/search/114台北市內湖區瑞光路513巷22弄5號5樓" target="_blank">114台北市內湖區瑞光路513巷22弄5號5樓</a>
              零壹科技售後服務中心 收
            </div>
            <hr />
            <div class="row mt-5">
              <div class="col">
                <BaseButton class="isStylePrimary isSmall isRadius isOutline2 w-100 mb-3" @click="againSend('application')"> 再次申請 </BaseButton>
              </div>
              <div class="col">
                <BaseButton class="isStylePrimary isSmall isRadius isOutline2 w-100 mb-3" :to="{ name: 'home' }"> 回首頁 </BaseButton>
              </div>
            </div>
          </template>
          <!--<pre>{{ applicationSubmitData }}</pre>-->
        </div>
        <!--維修進度查詢-->
        <div v-if="activeSeriveType === 'query'" :class="$style.contactBox" class="bg-gray-2">
          <div class="contactBox__title">維修進度查詢</div>
          <BaseStep v-model="queryStepActive" :list="queryStepList" />
          <hr />
          <!--步驟一-->
          <template v-if="queryStepActive === 0">
            <BaseForm
              ref="queryForm"
              key="query"
              v-model="querySubmitData"
              :loading="loadingQuerySubmit"
              :list="queryFiledList"
              confirm-text="送出查詢"
              @cancel="clearFrom('query')"
              @submit="onSubmitQuery"
            />
          </template>
          <!--步驟二-->
          <template v-if="queryStepActive === 1">
            <div :class="$style.formDetail">
              查詢成功!!
              <br />查詢結果：<span class="color-primary">報修已完成!</span> <br />送件狀態：<span class="color-primary">{{ applicationSubmitData.sendWay }}</span>
              <hr />
              查修資料：
              <br />E-Mail：{{ applicationSubmitData.email || '（無）' }} <br />聯絡電話： {{ querySubmitData.phoneCode }} - {{ querySubmitData.phoneNumber }}
              <span v-if="querySubmitData.phoneExtension">ext {{ querySubmitData.phoneExtension }}</span>
            </div>
            <hr />
            <div class="row mt-5">
              <div class="col">
                <BaseButton class="isStylePrimary isSmall isRadius isOutline2 w-100 mb-3" :to="{ name: 'home' }"> 回首頁 </BaseButton>
              </div>
              <div class="col">
                <BaseButton :loading="loadingApplicationSubmit" class="isStylePrimary isSmall isRadius isOutline2 w-100 mb-3" @click="goToStep(2, 'query')"> 查看明細資料 </BaseButton>
              </div>
            </div>
          </template>
          <!--步驟三-->
          <template v-if="queryStepActive === 2">
            <div :class="$style.formDetail">
              查詢成功!!
              <br />查詢結果：<span class="color-primary">報修已完成!</span>
              <!-- <br>送件狀態：<span class="color-primary">{{ applicationSubmitData.sendWay }}</span> -->
              <hr />
              <el-collapse class="privacy__list isStyleBase">
                <el-collapse-item v-for="(item, index) in queryResults" :key="index" :title="`維修編號：${item.number} ｜ 報修日期：${item.date}`">
                  <div class="row">
                    <div class="formDetail__left col-md-6 col-12">
                      <div class="formDetail__filedList">
                        <div class="formDetail__filedList__item">
                          <span class="formDetailList__title"> 報修日期： </span>
                          <span v-html="formatFiled(item.date)" class="formDetailList__text"></span>
                        </div>
                        <!-- <div class="formDetail__filedList__item">
                          <span class="formDetailList__title">
                            客戶屬性：
                          </span>
                          <span v-html="formatFiled(applicationSubmitData.customer)"></span>
                        </div> -->
                        <div class="formDetail__filedList__item">
                          <span class="formDetailList__title"> 公司名稱： </span>
                          <span v-html="formatFiled(item.companyName)"></span>
                        </div>
                        <div class="formDetail__filedList__item">
                          <span class="formDetailList__title"> 聯絡人： </span>
                          <span v-html="formatFiled(item.contactName)"></span>
                        </div>
                        <div class="formDetail__filedList__item">
                          <span class="formDetailList__title"> 聯絡電話： </span>
                          {{ item.phoneNumber }}
                        </div>
                        <div class="formDetail__filedList__item">
                          <span class="formDetailList__title"> 手機： </span>
                          <span v-if="item.fax">
                            {{ item.fax }}
                          </span>
                          <span v-else class="text-gray-4"> (無) </span>
                        </div>
                        <div class="formDetail__filedList__item">
                          <span class="formDetailList__title"> 聯絡地址： </span>
                          {{ item.address }}
                        </div>
                        <div class="formDetail__filedList__item">
                          <span class="formDetailList__title"> E-mail： </span>
                          <span v-html="formatFiled(item.email)"></span>
                        </div>
                        <!-- <div class="formDetail__filedList__item">
                          <span class="formDetailList__title">
                            備用E-mail：
                          </span>
                          <span v-html="formatFiled(applicationSubmitData.backEmail)"></span>
                        </div> -->
                        <div class="formDetail__filedList__item">
                          <span class="formDetailList__title"> 其他資訊： </span>
                          <span v-html="formatFiled(item.otherInfo)"></span>
                        </div>
                      </div>
                    </div>
                    <div class="formDetail__right col-md-6 col-12">
                      <div class="formDetail__filedList">
                        <div class="formDetail__filedList__item">
                          <span class="formDetailList__title"> 廠牌： </span>
                          <span v-html="formatFiled(item.brand)"></span>
                        </div>
                        <div class="formDetail__filedList__item">
                          <span class="formDetailList__title"> 產品型號： </span>
                          <span v-html="formatFiled(item.productModel)"></span>
                        </div>
                        <div class="formDetail__filedList__item">
                          <span class="formDetailList__title"> 序號或ID： </span>
                          <span v-html="formatFiled(item.serialNumber)"></span>
                        </div>
                        <div class="formDetail__filedList__item">
                          <span class="formDetailList__title"> 送件方式： </span>
                          <span v-html="formatFiled(item.sendWay)"></span>
                        </div>
                        <div class="formDetail__filedList__item">
                          <span class="formDetailList__title"> 送修品狀態： </span>
                          <span v-html="formatFiled(item.objectStatus)"></span>
                        </div>
                        <!-- <div class="formDetail__filedList__item">
                          <span class="formDetailList__title">
                            故障代碼表：
                          </span>
                          <span v-html="formatFiled(applicationSubmitData.faultId)"></span>
                        </div> -->
                        <div class="formDetail__filedList__item">
                          <span class="formDetailList__title"> 故障描述： </span>
                          <span v-html="formatFiled(item.description)"></span>
                        </div>
                        <div class="formDetail__filedList__item">
                          <span class="formDetailList__title"> 維修品備註： </span>
                          <span v-html="formatFiled(item.memo)"></span>
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="row mt-5 formDetail__stepList no-gutters">
                        <div v-for="(stepItem, $index2) in item.step" :key="$index2" class="col-lg-2 col-md-3 col-sm-4 col-6 formDetail__stepItem" :class="{ isActive: stepItem }">
                          <div class="step">
                            {{ stepTitle($index2) }}
                          </div>
                          <div class="date">
                            {{ stepItem }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </el-collapse-item>
              </el-collapse>
            </div>
            <hr />
            <div class="row mt-5">
              <div class="col">
                <BaseButton class="isStylePrimary isSmall isRadius isOutline2 w-100" @click="againSend('query')"> 再次查詢 </BaseButton>
              </div>
              <div class="col">
                <BaseButton class="isStylePrimary isSmall isRadius isOutline2 w-100" :to="{ name: 'home' }"> 回首頁 </BaseButton>
              </div>
            </div>
          </template>
          <!--<pre>{{ applicationSubmitData }}</pre>-->
        </div>
      </div>
      <el-dialog :visible.sync="dialogVisible" width="1200px" class="isStyleBigImg">
        <img src="@assets/images/repair/detail.jpg" alt="" />
      </el-dialog>
    </section>
    <section :class="$style.sectionProcess" class="section pt-0">
      <div class="container">
        <div class="text-center">
          <BaseSectionTitle title="維修服務流程" />
          <div class="py-2 px-3 mb-3 d-inline-block" style="background: #fff0f0">
            *ZOT印表伺服器之維修服務自2018/06/02起轉由<a class="text-primary hover:text-primary-hover" target="_blank" style="text-decoration: underline" href="http://www.zot.com.tw/">源壹科技</a>服務
          </div>
          <div class="mb-5"> 經維修中心電話確認為故障品後，客戶由零壹企業網站（維修服務）填寫線上維修單，維修中心處理完畢後，再由維修中心送還給客戶。 </div>
        </div>
        <div :class="$style.contactBox" class="bg-gray-2">
          <BaseStep v-model="activeProcessStep" :list="processStepList" class="sectionProcess__step" />
          <hr />
          <div class="mb-4">
            <button class="contactBox__toggle" @click="showProcessImg = !showProcessImg">
              查看詳細流程
              <i class="fal ml-2 contactBox__toggle__icon" :class="showProcessImg ? 'fa-chevron-up' : 'fa-chevron-down'"> </i>
            </button>
            <div class="mt-3">
              <img v-show="showProcessImg" alt="" src="@assets/images/repair/detail.jpg" />
              <BaseButton v-show="showProcessImg" class="isStylePrimary isSmall isFull isRadius mt-4 mb-5 d-md-none" @click="dialogVisible = !dialogVisible">
                <i class="fal fa-search-plus"></i> 查看大圖
              </BaseButton>
            </div>
          </div>

          <div class="font-medium mb-2"> 流程說明 </div>
          <ul class="text-base md:text-lg">
            <li>貨品於保固期間內為免費服務，不含配件（如變壓器）及天災如（泡水）等損壞。</li>
            <li>若須收費維修，本公司將會事先報價，由客戶自行決定是否送修。</li>
            <li>客戶可經由維修進度查詢依維修編號或是聯絡人電子郵件及行動電話查詢維修進度。</li>
            <li>各項贈品不在本公司服務範圍內，請洽各贈品之原廠 。</li>
          </ul>
          <div class="contactBox__innerBox">
            維修專線: <a href="tel:0800-80-5656">0800-80-5656</a> / <a href="tel:02-26565724">02-26565724</a> <br />送修地址:
            <a href="https://www.google.com.tw/maps/search/114台北市內湖區瑞光路513巷22弄5號5樓" target="_blank">114台北市內湖區瑞光路513巷22弄5號5樓</a>
            零壹科技售後服務中心 收
          </div>
        </div>
      </div>
    </section>
  </ContactLayout>
</template>
<style lang="scss" module>
.sectionProcess {
  :global {
    .sectionProcess {
      &__step {
        @include max-md {
          flex-direction: column;
          .el-step__line-inner {
            display: none;
          }
          .el-step {
            max-width: 100% !important;
            margin-bottom: 1rem;
          }
        }
      }
    }
  }
}

.contactBox {
  padding: 3.75rem 3.125rem;

  @include max-md {
    padding: 2rem 1rem;
  }

  :global {
    .contactBox {
      &__title {
        margin-bottom: 3.75rem;
        font-size: 1.5rem;
        font-weight: 500;
        text-align: center;
      }

      &__toggle {
        padding: 0;
        text-decoration: underline;
        letter-spacing: 0.15em;
        background: transparent;
        border: unset;
        appearance: none;

        &__icon {
          text-decoration: none;
        }

        &:hover {
          color: $color-primary;
        }

        &:focus {
          outline: none;
        }

        &:active {
          color: darken($color-primary, 10%);
        }
      }

      &__innerBox {
        padding: 1.5rem;
        line-height: 2;
        color: $color-gray-6;
        background: #fff;

        a {
          color: $color-gray-6;

          &:hover {
            color: $color-primary;
            text-decoration: none;
          }
        }
      }
    }

    ul {
      padding-left: 1.5rem;

      li {
        line-height: 2;
        color: $color-gray-6;

        &::marker {
          color: $color-primary;
        }
      }
    }

    .privacy {
      &__list {
        .el-collapse-item {
          &__header {
            padding-top: 25px;
            padding-bottom: 25px;
            font-size: 1.1rem;

            @include max-md {
              font-size: 1.2rem;
            }
          }

          &__content {
            padding-top: 1.5rem;
            padding-bottom: 1.5rem;
            font-size: 1rem;

            p {
              margin-bottom: 10px;
            }

            ul {
              margin-left: -1em;

              &.ml--4 {
                margin-left: -4px;
              }
            }
          }
        }
      }
    }
  }
}

.formDetail {
  padding: 3.75rem 4rem;
  font-size: 1rem;
  line-height: 2;
  background: #fff;

  @include max-md {
    padding: 2.75rem 1.8rem;
  }

  a {
    color: $color-gray-7;

    &:hover {
      color: $color-primary;
      text-decoration: none;
    }
  }

  :global {
    .formDetail {
      &__left {
        border-right: 1px solid #b1baca;

        @include max-md {
          padding-bottom: 1rem;
          margin-bottom: 1rem;
          border-right: 0;
          border-bottom: 1px solid #b1baca;
        }
      }

      &__right {
        .formDetail__filedList__item {
          padding-left: 20px;

          @include max-md {
            padding-left: 0;
          }
        }
      }

      &__filedList {
        margin-bottom: -2rem;

        &__item {
          margin-bottom: 2rem;
        }

        &__title {
          display: inline-block;
          min-width: 7em;
        }

        &__text {
        }
      }
      &__stepList {
        margin-top: -1rem;
      }
      &__stepItem {
        margin-bottom: 1rem;
        text-align: center;
        .date {
          margin-top: 0.8rem;
          padding: 0 1rem;
          height: 28px;
        }
        .step {
          color: $color-gray-5;
          padding: 0 1rem 0.2rem 1rem;
          border-bottom: 2px solid $color-primary;
        }
        &.isActive {
          .step {
            color: $color-primary;
          }
        }
      }
    }
  }
}

.sectionApplication {
  :global {
    .isStyleBigImg {
      .el-dialog {
        max-width: inherit;
        overflow: auto;
      }
    }
  }
}
</style>
